import { RootState } from "../lib/store";
import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { logout } from "../lib/slices/auth.slice";
import { clearTempData } from "../lib/slices/temp.slice";

const staggeredBaseQuery = retry(
  async (args, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: "https://api.outsella.com/",
      prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.authToken;
        if (!headers.has("authorization"))
          headers.set(
            "authorization",
            `Token ${token || "5ea8cd22386b722968a5d9dab60ba6e18149b767"}`
          );
        return headers;
      },
    })(args, api, extraOptions);

    if (result.error?.status === 401 || result.error?.status === 403) {
      const retryResult = await fetchBaseQuery({
        baseUrl: "https://api.outsella.com/",
        prepareHeaders: (headers) => {
          headers.set(
            "authorization",
            "Token 5ea8cd22386b722968a5d9dab60ba6e18149b767"
          );
          console.debug("trying again...", headers);
          return headers;
        },
      })(args, api, extraOptions);

      if (retryResult.error?.status === 401) {
        api.dispatch(logout());
        api.dispatch(clearTempData());
        localStorage.clear();
        window.location.reload();
      }
      return retryResult;
    }

    return result;
  },
  {
    maxRetries: 0,
  }
);

export const baseApi = createApi({
  reducerPath: "baseApi",
  tagTypes: ["Agent", "WidgetConfig", "Chat", "Auth", "TrainingData"],
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
});
